import { RESET_STATE } from 'src/redux/actions';
import { datepikerActionsTypes } from './datepikerActionsTypes';

const { FILTER_DATE } = datepikerActionsTypes;

const intialState = {
	filterDates: [],
};

export const datepikerReducers = (state = intialState, { type, payload }) => {
	switch (type) {
		case FILTER_DATE:
			return { ...state, filterDates: payload };
		case RESET_STATE:
			return intialState;
		default:
			return state;
	}
};
